// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 767px) {
  header {
    position: sticky;
    top: 0;
    background-color: var(--bgPrimary);
    z-index: 1002;
  }
}
header nav {
  padding: 1.125rem 0 !important;
}
@media screen and (max-width: 767px) {
  header nav {
    padding: 0.25rem 0 !important;
  }
}
header nav .navbar-brand {
  cursor: pointer;
}
header nav .navbar-brand img {
  filter: drop-shadow(0px 0px 10px rgba(181, 25, 255, 0.302));
}
@media screen and (max-width: 767px) {
  header nav .navbar-brand img {
    max-width: 110px;
  }
}
header nav .navbar-wallet-btn {
  min-width: 204px;
}
@media screen and (max-width: 767px) {
  header nav .navbar-wallet-btn {
    min-width: unset;
    width: 100%;
  }
}
header nav .btn {
  min-height: 42px;
}
header nav .setting-dropdown .dropdown-menu {
  background-color: var(--dropdownMenuBg);
  outline: 2px solid var(--purpleColor-3);
  outline-offset: -2px;
  min-width: 280px;
  border-radius: 1rem;
  padding: 1rem;
  z-index: 1002;
}
header nav .setting-dropdown .dropdown-menu.show {
  animation: 500ms ease-in slidein;
}
@media screen and (max-width: 767px) {
  header nav .setting-dropdown .dropdown-menu.show {
    position: fixed;
    right: 0;
    left: 0;
    top: 50px;
    max-width: 310px;
    margin: auto;
    animation: none;
  }
}
header nav .setting-dropdown .dropdown-menu .switch-settings {
  background-color: var(--bgPrimary);
  padding: 0 1rem;
  border-radius: 0.625rem;
  list-style: none;
}
header nav .setting-dropdown .dropdown-menu .switch-settings li {
  padding: 0 !important;
}
header nav .setting-dropdown .dropdown-menu .switch-settings li:last-child .dropdown-item {
  border-bottom: 0;
}
header nav .setting-dropdown .dropdown-menu li:not(:last-child) .dropdown-item {
  border-bottom: 1px solid var(--purpleExDark);
}
header nav .setting-dropdown .dropdown-menu li .dropdown-item {
  padding: 0.75rem 0;
  color: var(--white);
  font-weight: 500;
}
header nav .setting-dropdown .dropdown-menu li .dropdown-item:hover, header nav .setting-dropdown .dropdown-menu li .dropdown-item:focus, header nav .setting-dropdown .dropdown-menu li .dropdown-item:visited {
  background-color: transparent;
  color: var(--secondary);
  outline: 0;
}
header nav .setting-dropdown .dropdown-menu li .dropdown-item:hover svg, header nav .setting-dropdown .dropdown-menu li .dropdown-item:focus svg, header nav .setting-dropdown .dropdown-menu li .dropdown-item:visited svg {
  stroke: var(--secondary) !important;
}
header nav .setting-dropdown .dropdown-menu li:not(:first-child) {
  padding: 0 0.8rem;
}
@media screen and (min-width: 767px) {
  header nav .setting-dropdown [aria-expanded=false] + .dropdown-menu {
    animation: 500ms ease-out slideout;
  }
}
header nav .setting-dropdown .setting-user-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50em;
  color: var(--white);
  font-weight: 700;
  background-color: var(--userIconBg);
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
header nav .setting-dropdown .btn-close-modal {
  margin-top: -12px;
  margin-right: -6px;
}
@media screen and (max-width: 767px) {
  header nav .navbar-nav .nav-item:first-child {
    min-width: 100px;
    max-width: 167px;
    width: 100%;
  }
}

@media screen and (max-width: 767px) {
  body:has(.setting-dropdown .dropdown-menu.show) #root:after,
  body:has(.setting-dropdown .dropdown-menu.show) header:after {
    content: "";
    background-color: var(--black-8);
    position: fixed;
    inset: 0;
    z-index: 888;
  }
  body:has(.setting-dropdown .dropdown-menu.show) header:after {
    bottom: auto;
    height: 66px;
  }
}
@keyframes slidein {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slideout {
  0% {
    transform: translateX(-80%);
    display: block;
    opacity: 1;
  }
  70% {
    transform: translateX(20%);
    display: none;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/Header.scss"],"names":[],"mappings":"AACE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,kCAAA;IACA,aAAA;EACF;AACF;AAAE;EACE,8BAAA;AAEJ;AADI;EAFF;IAGI,6BAAA;EAIJ;AACF;AAHI;EACE,eAAA;AAKN;AAJM;EACE,2DAAA;AAMR;AALQ;EAFF;IAGI,gBAAA;EAQR;AACF;AAJI;EACE,gBAAA;AAMN;AALM;EAFF;IAGI,gBAAA;IACA,WAAA;EAQN;AACF;AALI;EACE,gBAAA;AAON;AAHM;EACE,uCAAA;EACA,uCAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AAKR;AAHQ;EACE,gCAAA;AAKV;AAJU;EAFF;IAGI,eAAA;IACA,QAAA;IACA,OAAA;IACA,SAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;EAOV;AACF;AALQ;EACE,kCAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AAOV;AALU;EACE,qBAAA;AAOZ;AAJc;EACE,gBAAA;AAMhB;AAEY;EACE,4CAAA;AAAd;AAIU;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AAFZ;AAIY;EACE,6BAAA;EACA,uBAAA;EACA,UAAA;AAFd;AAGc;EACE,mCAAA;AADhB;AAOU;EACE,iBAAA;AALZ;AAWQ;EADF;IAEI,kCAAA;EARR;AACF;AAWM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATR;AAYM;EACE,iBAAA;EACA,kBAAA;AAVR;AAgBU;EADF;IAEI,gBAAA;IACA,gBAAA;IACA,WAAA;EAbV;AACF;;AAmBA;EAGI;;IACE,WAAA;IACA,gCAAA;IACA,eAAA;IACA,QAAA;IACA,YAAA;EAjBJ;EAqBE;IACE,YAAA;IACA,YAAA;EAnBJ;AACF;AAuBA;EACE;IACE,2BAAA;IACA,UAAA;EArBF;EAwBA;IACE,wBAAA;IACA,UAAA;EAtBF;AACF;AAyBA;EACE;IACE,2BAAA;IACA,cAAA;IACA,UAAA;EAvBF;EA0BA;IACE,0BAAA;IACA,aAAA;IACA,UAAA;EAxBF;AACF","sourcesContent":["header {\n  @media screen and (max-width: 767px) {\n    position: sticky;\n    top: 0;\n    background-color: var(--bgPrimary);\n    z-index: 1002;\n  }\n  nav {\n    padding: 1.125rem 0 !important;\n    @media screen and (max-width: 767px) {\n      padding: 0.25rem 0 !important;\n    }\n    .navbar-brand {\n      cursor: pointer;\n      img {\n        filter: drop-shadow(0px 0px 10px rgba(181, 25, 255, 0.302));\n        @media screen and (max-width: 767px) {\n          max-width: 110px;\n        }\n      }\n    }\n\n    .navbar-wallet-btn {\n      min-width: 204px;\n      @media screen and (max-width: 767px) {\n        min-width: unset;\n        width: 100%;\n      }\n    }\n\n    .btn {\n      min-height: 42px;\n    }\n\n    .setting-dropdown {\n      .dropdown-menu {\n        background-color: var(--dropdownMenuBg);\n        outline: 2px solid var(--purpleColor-3);\n        outline-offset: -2px;\n        min-width: 280px;\n        border-radius: 1rem;\n        padding: 1rem;\n        z-index: 1002;\n\n        &.show {\n          animation: 500ms ease-in slidein;\n          @media screen and (max-width: 767px) {\n            position: fixed;\n            right: 0;\n            left: 0;\n            top: 50px;\n            max-width: 310px;\n            margin: auto;\n            animation: none;\n          }\n        }\n        .switch-settings {\n          background-color: var(--bgPrimary);\n          padding: 0 1rem;\n          border-radius: 0.625rem;\n          list-style: none;\n\n          li {\n            padding: 0 !important;\n\n            &:last-child {\n              .dropdown-item {\n                border-bottom: 0;\n              }\n            }\n          }\n        }\n\n        li {\n          &:not(:last-child) {\n            .dropdown-item {\n              border-bottom: 1px solid var(--purpleExDark);\n            }\n          }\n\n          .dropdown-item {\n            padding: 0.75rem 0;\n            color: var(--white);\n            font-weight: 500;\n\n            &:hover, &:focus, &:visited {\n              background-color: transparent;\n              color: var(--secondary);\n              outline: 0;\n              svg {\n                stroke: var(--secondary) !important;\n              }\n            }\n\n          }\n\n          &:not(:first-child) {\n            padding: 0 0.8rem;\n          }\n        }\n      }\n\n      & [aria-expanded=false]+.dropdown-menu {\n        @media screen and (min-width: 767px) {\n          animation: 500ms ease-out slideout;\n        }\n      }\n\n      .setting-user-icon {\n        width: 3rem;\n        height: 3rem;\n        border-radius: 50em;\n        color: var(--white);\n        font-weight: 700;\n        background-color: var(--userIconBg);\n        font-size: 1.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .btn-close-modal {\n        margin-top: -12px;\n        margin-right: -6px;\n      }\n    }\n    .navbar-nav {\n      .nav-item {\n        &:first-child {\n          @media screen and (max-width: 767px) {\n            min-width: 100px;\n            max-width: 167px;\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n}\n@media screen and (max-width: 767px) {\n  body:has(.setting-dropdown .dropdown-menu.show) #root,\n  body:has(.setting-dropdown .dropdown-menu.show) header {\n    &:after {\n      content: '';\n      background-color: var(--black-8);\n      position: fixed;\n      inset: 0;\n      z-index: 888;\n    }\n  }\n  body:has(.setting-dropdown .dropdown-menu.show) header {\n    &:after {\n      bottom: auto;\n      height: 66px;\n    }\n  }\n}\n\n@keyframes slidein {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideout {\n  0% {\n    transform: translateX(-80%);\n    display: block;\n    opacity: 1;\n  }\n\n  70% {\n    transform: translateX(20%);\n    display: none;\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
